import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ContactDeleteDialog = ({ confirmation, onCancel, onConfirm, t = {} }) => (
  <Dialog open={confirmation.open} onClose={onCancel}>
    <DialogTitle>{t.deleteConfirmationTitle || 'Delete Contact'}</DialogTitle>
    <DialogContent>
      <Typography>
        {t.deleteConfirmationMessage || 'Are you sure you want to delete'} {confirmation.contactName}?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>
        {t.cancel || 'Cancel'}
      </Button>
      <Button onClick={onConfirm} autoFocus>
        {t.delete || 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ContactDeleteDialog;
